<template>
  <div>
    <!-- <a-form-model-item > -->
      <a-row v-for="(item, index) in form.spec" :key="index" class="d-flex">
        <a-form-model-item style="flex: 1 1 auto" :rules="rules.spec_key" :prop="`spec.${index}.key`">
          <a-input v-model="item.key" :placeholder="$t('bill.rate.spec_name')" />
        </a-form-model-item>
        <span style="flex: 0 0 20px;text-align:center">:</span>
        <a-form-model-item style="flex: 1 1 auto" :rules="rules.spec_value" :prop="`spec.${index}.value`">
          <a-input v-model="item.value" :placeholder="$t('bill.rate.spec_value')" />
        </a-form-model-item>
        <span class="ml-2" style="flex: 0 0 20px;text-align:center">
          <a-button shape="circle" icon="minus" size="small" @click="delSpec(index)" />
        </span>
      </a-row>
    <!-- </a-form-model-item> -->
    <a-button type="link" @click="addSpec"><a-icon type="plus" style="padding: 0" /> {{$t('bill.rate.add_spec')}}</a-button>
  </div>
</template>

<script>
export default {
  name: 'SpecEditor',
  props: {
    form: Object,
    rules: Object,
  },
  data () {
    return {
      // specList: this.spec,
    }
  },
  methods: {
    addSpec () {
      this.form.spec.push({ key: '', value: '' })
    },
    delSpec (index) {
      this.form.spec = this.form.spec.filter((item, idx) => index !== idx)
    },
  },
}
</script>
